
  import { defineComponent, PropType } from 'vue';

  import Constants from '@/common/constants';
  import { downloadPDF } from '@/common/utils/fileExport';

  import { TStatisticsPublicFilter } from '@/modules/admin/types/statistics/statistics-public';
  import { statisticsPublicClonedNodeFormatter } from '@/modules/admin/utils/pdf/statisticsPublicPdfFormatter';

  import API from '../../../api/statisticsPublic';
  import StatisticsExportButtons from '../StatisticsExportButtons.vue';

  export default defineComponent({
    name: 'StatisticsPublicExportButtons',
    components: { StatisticsExportButtons },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPublicFilter>,
        required: true,
      },
    },
    data(): {
      isExportProgress: boolean;
      exportPermission: number;
    } {
      return {
        isExportProgress: false,
        exportPermission: Constants.Permissions.AuditPublicStatisticExport,
      };
    },
    methods: {
      async exportPdf() {
        this.isExportProgress = true;

        try {
          await downloadPDF({
            clonedElementClassName: 'statistics-public__export-pdf',
            fileName: 'Статистика посещений. Публичная часть',
            clonedNodeFormatter: statisticsPublicClonedNodeFormatter,
            opt: {
              margin: { top: 15, right: 0, bottom: 20, left: 0 },
            },
          });
        } catch (e) {
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.debug('PDF export failed:', e);
          }
        } finally {
          this.isExportProgress = false;
        }
      },
      async exportExcel() {
        this.isExportProgress = true;

        try {
          await API.exportExcel(this.filter);
        } finally {
          this.isExportProgress = false;
        }
      },
    },
  });
